var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox-group',{on:{"change":_vm.changeCheck},model:{value:(_vm.checkList),callback:function ($$v) {_vm.checkList=$$v},expression:"checkList"}},_vm._l((_vm.myoptions),function(item){return _c('el-checkbox',{key:item.vid,attrs:{"label":item.vid}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }